module.exports = __webpack_public_path__ + "static/media/user-alien.5efc943a.svg";